import PropTypes from "prop-types";
import React, { useState } from "react";
import angular from "../../assets/images/angular.png";
import javascript from "../../assets/images/javascript.png";
import laravel from "../../assets/images/laravel.png";
import nextjs from "../../assets/images/nextjs.png";
import node from "../../assets/images/node.png";
import php from "../../assets/images/php.png";
import react from "../../assets/images/react.png";
import reactnative from "../../assets/images/reactnative.png";
import spring from "../../assets/images/spring.png";
import three from "../../assets/images/three.png";
import classes from "./Demo.module.css";

const IconFilter = ({ onFilter, setMakeScroll }) => {
  const [selectedIcon, setSelectedIcon] = useState(null);

  const icons = [
    { id: 1, name: "Laravel", img: laravel, class: "laravel" },
    { id: 2, name: "Php", img: php, class: "php" },
    { id: 3, name: "Node", img: node, class: "node" },
    { id: 4, name: "Spring boot", img: spring, class: "spring" },
    { id: 5, name: "Javascript", img: javascript, class: "javascript" },
    { id: 6, name: "React", img: react, class: "react" },
    { id: 7, name: "Next.js", img: nextjs, class: "nextjs" },
    { id: 8, name: "React native", img: reactnative, class: "reactnative" },
    { id: 9, name: "Angular", img: angular, class: "angular" },
    { id: 10, name: "Three", img: three, class: "three" },
  ];

  const handleIconClick = (tecnology) => {
    setSelectedIcon(tecnology);
    onFilter(tecnology);
    setMakeScroll(true);
  };

  return (
    <div className={classes.iconFilterContainer}>
      {icons.map((icon) => (
        <div
          key={icon.name}
          className={classes.iconFilterExt}
          onClick={() => handleIconClick(icon.name)}
        >
          <div
            className={`${classes.iconFilter} ${classes[icon.class]} ${
              selectedIcon === icon.name ? classes.selected : ""
            }`}
          >
            <img src={icon.img} alt={icon.name} className={classes.iconImg} />
          </div>
          <span className={classes.iconText}>{icon.name}</span>
        </div>
      ))}
      <div
        key="all"
        className={classes.iconFilterExt}
        onClick={() => handleIconClick("all")}
      >
        <div
          className={`${classes.iconFilter} iconAll ${
            selectedIcon === "all" ? classes.selected : ""
          }`}
        >
          <span>all</span>
        </div>
        <span className={classes.iconText}>All</span>
      </div>
    </div>
  );
};

IconFilter.propTypes = {
  onFilter: PropTypes.func.isRequired,
};

export default IconFilter;
